export const VISIBILITY_STATE = {
  MINIMIZED: 'MINIMIZED',
  MAXIMIZED: 'MAXIMIZED',
  STACKED: 'STACKED'
}
